import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

export default createStore({
  state: {
    user: null,
    token: null,
    isLogin: false,
    language: 'en',
    totalElementos: 0,
    totalActivos: 0,
    location: null,
  },
  getters: {
    getUser: (state) => state.user,
    getToken: (state) => state.token,
    getIsLogin: (state) => state.isLogin,
    getLanguage: (state) => state.language,
    getTotalElementos: (state) => state.totalElementos,
    getTotalActivos: (state) => state.totalActivos,
    getLocation: (state) => state.location,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setToken(state, payload) {
      state.token = payload;
    },
    setIsLogin(state, payload) {
      state.isLogin = payload;
    },
    setLogout(state) {
      state.user = null;
      state.token = null;
      state.isLogin = false;
    },
    setLanguage(state, payload) {
      state.language = payload;
    },
    setTotalElementos(state, payload) {
      state.totalElementos = payload;
    },
    setTotalActivos(state, payload) {
      state.totalActivos = payload;
    },
    setLocation(state, payload) {
      state.location = payload;
    },
  },
  actions: {
    setUser(context, payload) {
      context.commit('setUser', payload);
    },
    setToken(context, payload) {
      context.commit('setToken', payload);
    },
    setIsLogin(context, payload) {
      context.commit('setIsLogin', payload);
    },
    setLanguage(context, payload) {
      context.commit('setLanguage', payload);
    },
    setTotalElementos(context, payload) {
      context.commit('setTotalElementos', payload);
    },
    setTotalActivos(context, payload) {
      context.commit('setTotalActivos', payload);
    },
    setLocation(context, payload) {
      context.commit('setLocation', payload);
    },
  },
  modules: {},
  plugins: [createPersistedState()],
});
